import { useCallback, useSyncExternalStore } from 'react';
import { usePlayerContext } from '../../ui-react/PlayerContext';
import { useStore } from '../../ui-react/hooks/useStore';
import { TheatreEnterIcon } from './TheatreIcons';
import { Tooltip } from '../../ui-react/controls/Tooltip';
import styles from './TheatreBtn.module.css';

const mq = typeof window !== 'undefined' ? window.matchMedia('(max-width: 768px)') : null;

function useIsMobile() {
  return useSyncExternalStore(
    cb => { mq?.addEventListener('change', cb); return () => mq?.removeEventListener('change', cb); },
    () => mq?.matches ?? false,
    () => false,
  );
}

export function TheatreBtn() {
  const isMobile = useIsMobile();
  const { store, eventBus } = usePlayerContext();
  const isTheatre = useStore(store, useCallback(s => s.isTheatreMode, []));

  const handleClick = useCallback(() => {
    eventBus.emit('theatre:change', !store.getState().isTheatreMode);
    const body = document.getElementsByTagName('body')[0];
    body.classList.toggle('theatre');
  }, [eventBus, store]);

  if (isMobile) return null;

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={`${styles.btn}${isTheatre ? ` ${styles.active}` : ''}`}
        onClick={handleClick}
      >
        <span className={styles.iconEnter}><TheatreEnterIcon /></span>
        <span className={styles.iconExit}><TheatreEnterIcon /></span>
      </button>
      <Tooltip label={isTheatre ? 'Выйти из театрального режима' : 'Театральный режим'} shortcut="Alt + t" />
    </div>
  );
}
